// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"om_a bhh_qr bhh_a bhh_w","FaqAskQuestion__outdated":"om_b bhh_vp bhh_xe"};